module.exports = __webpack_public_path__ + "static/natalie-portman-8677121afd8a4a4598fdc3b99017ce76.jpg";